import { render } from "./NavMenu.vue?vue&type=template&id=d7799a46"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script